import { useState, useEffect } from "react";
import api from "../api";

const BRL = n => (Number(n)||0).toLocaleString("pt-BR",{ style:"currency", currency:"BRL", maximumFractionDigits:2 });
const PCT = n => (Number(n)*100).toLocaleString("pt-BR",{ maximumFractionDigits:2 })+"%";
const ORANGE = "#EE6A1A";
const mesAtual = () => new Date().toISOString().slice(0,7);
const shiftMes = (m,d) => { const [y,mo]=m.split("-").map(Number); return new Date(y, mo-1+d, 1).toISOString().slice(0,7); };
const fmtData = s => { if(!s||s.length<10) return "—"; const [y,m,d]=s.slice(0,10).split("-"); return d+"/"+m+"/"+y; };

const PADRAO = {
  faixas: [ {ate:50000,pct:0.04},{ate:150000,pct:0.05},{ate:300000,pct:0.06},{ate:null,pct:0.065} ],
  retencao: 0.20, recFech: 0.30, recResid: 0.03, recParcelas: 11,
};
function loadParams(){
  try{ const p=JSON.parse(localStorage.getItem("crm_comissao_params")); if(p&&p.faixas) return {...PADRAO,...p}; }catch(e){}
  return PADRAO;
}
function comProjeto(par, valorServicos, origem, reter){
  const lim=[0,...par.faixas.map(f=>f.ate==null?Infinity:f.ate)];
  let bruta=0;
  par.faixas.forEach((f,i)=>{ const de=lim[i], ate=f.ate==null?Infinity:f.ate; bruta += Math.max(0,Math.min(Number(valorServicos)||0,ate)-de)*f.pct; });
  const aposMult=bruta*Number(origem);
  const ret=reter?aposMult*par.retencao:0;
  return { bruta, aposMult, ret, aPagar: aposMult-ret };
}
function comRec(par, mensalidade){
  const M=Number(mensalidade)||0;
  const fech=M*par.recFech, resMes=M*par.recResid, resTot=resMes*par.recParcelas;
  return { fech, resMes, resTot, tot: fech+resTot };
}
function mesesContrato(r){
  if(r.dataInicio && r.dataFim && r.dataInicio.length>=7 && r.dataFim.length>=7){
    const [ay,am]=r.dataInicio.slice(0,7).split("-").map(Number);
    const [by,bm]=r.dataFim.slice(0,7).split("-").map(Number);
    const d=(by-ay)*12+(bm-am);
    return d>0?d:12;
  }
  return 12;
}
function valorContrato(r){ return (Number(r.mensalidade)||0)*mesesContrato(r); }
function mesesDesde(selMes, r){
  const start = (r.dataInicio && r.dataInicio.length>=7) ? r.dataInicio.slice(0,7) : (r.mes||"");
  if(!start || !selMes) return null;
  const [sy,sm]=selMes.split("-").map(Number);
  const [ay,am]=start.split("-").map(Number);
  return (sy-ay)*12 + (sm-am);
}
function situacaoRec(par, selMes, r){
  const ms=mesesDesde(selMes,r); const c=comRec(par,r.mensalidade);
  if(ms===null) return { txt:"—", val:0, cor:"var(--text-muted)" };
  if(ms<0)  return { txt:"Antes do início", val:0, cor:"var(--text-muted)" };
  if(ms===0) return { txt:"Fechamento", val:c.fech, cor:"#6c5ce7" };
  if(ms>=1 && ms<=par.recParcelas) return { txt:"Residual · mês "+(ms+1), val:c.resMes, cor:"#0984e3" };
  return { txt:"Encerrado", val:0, cor:"var(--text-muted)" };
}
function alertaFim(dataFim){
  if(!dataFim || dataFim.length<10) return null;
  const fim=new Date(dataFim.slice(0,10)+"T00:00:00"); const hoje=new Date(); hoje.setHours(0,0,0,0);
  const dias=Math.round((fim-hoje)/86400000);
  if(dias<0)  return { txt:"Vencido", cor:"#e2445c" };
  if(dias<=60) return { txt:"Vence em "+dias+"d", cor:"#EE6A1A" };
  return null;
}

const card = { background:"var(--card-bg)", border:"1px solid var(--border-color)", borderRadius:14, padding:20, boxShadow:"0 1px 3px rgba(0,0,0,.04)" };
const lbl  = { fontSize:10.5, fontWeight:600, color:"var(--text-muted)", textTransform:"uppercase", letterSpacing:".04em", display:"block", marginBottom:5 };
const inp  = { width:"100%", boxSizing:"border-box", background:"var(--hover-bg)", border:"1.5px solid var(--border-color)", borderRadius:8, padding:"9px 11px", color:"var(--text-primary)", fontSize:13, outline:"none", fontFamily:"'Inter',sans-serif", height:38 };
const secTit= { fontSize:12, fontWeight:800, color:ORANGE, textTransform:"uppercase", letterSpacing:".05em", marginBottom:14 };
const th = { fontSize:10.5, fontWeight:600, color:"var(--text-muted)", textTransform:"uppercase", letterSpacing:".03em", textAlign:"left", padding:"8px", borderBottom:"1px solid var(--border-color)" };
const td = { fontSize:13, color:"var(--text-secondary)", padding:"9px 8px", borderTop:"1px solid var(--border-light)" };
const btnAdd = { height:38, background:ORANGE, border:"none", borderRadius:8, padding:"0 16px", color:"#fff", fontWeight:700, fontSize:13, cursor:"pointer", whiteSpace:"nowrap" };
const iconBtn = { cursor:"pointer", fontSize:14, padding:"0 4px" };

function Money({ value, onChange, style }){
  const disp = (value===""||value==null||Number(value)===0) ? "" : BRL(value);
  return <input value={disp} placeholder="R$ 0,00" style={{ ...inp, textAlign:"right", ...style }}
    onChange={e=>{ const d=e.target.value.replace(/\D/g,""); onChange(d? Number(d)/100 : 0); }}/>;
}

export default function Comissoes({ currentUser }){
  const isGestor = ["admin","gerente"].includes(currentUser && currentUser.role);
  const [par,setPar]     = useState(loadParams);
  const [openPar,setOpenPar] = useState(false);
  useEffect(()=>{ try{ localStorage.setItem("crm_comissao_params", JSON.stringify(par)); }catch(e){} },[par]);

  const [usuarios,setUsuarios] = useState([]);
  const [regs,setRegs]   = useState([]);
  const [pagos,setPagos] = useState([]);
  const [mes,setMes]     = useState(mesAtual);
  const [vend,setVend]   = useState("");

  const carregar = async()=>{ try{ const {data}=await api.get("/comissoes"); setRegs(Array.isArray(data)?data:[]); }catch(e){ setRegs([]); } };
  const carregarPagos = async(m)=>{ try{ const {data}=await api.get("/comissoes/pagamentos",{ params:{ mes:m||mes } }); setPagos(Array.isArray(data)?data:[]); }catch(e){ setPagos([]); } };
  useEffect(()=>{ (async()=>{ try{ const {data}=await api.get("/users"); const us=Array.isArray(data)?data:(data.users||[]); setUsuarios(us); setVend(!isGestor && currentUser ? currentUser.nome : ((us[0]&&us[0].nome)||"")); }catch(e){ if(!isGestor && currentUser) setVend(currentUser.nome); } })(); carregar(); },[]);
  useEffect(()=>{ carregarPagos(mes); },[mes]);

  const projsDe = (nome)=> regs.filter(r=>r.vendedor===nome && r.tipo==="projeto" && r.mes===mes);
  const recsDe  = (nome)=> regs.filter(r=>r.vendedor===nome && r.tipo==="recorrente");
  const totalVend = (nome)=>{
    let p=0,f=0,rm=0;
    projsDe(nome).forEach(r=>{ p+=comProjeto(par,r.valorServicos,r.origem,r.reter).aPagar; });
    recsDe(nome).forEach(r=>{ const s=situacaoRec(par,mes,r); if(s.txt==="Fechamento") f+=s.val; else if(s.txt.indexOf("Residual")===0) rm+=s.val; });
    return { proj:p, fech:f, resMes:rm, total:p+f+rm };
  };
  const totalFechado = (nome)=>{
    let projServ=0, mrrTotal=0, valorContratos=0;
    projsDe(nome).forEach(r=>{ projServ+=Number(r.valorServicos)||0; });
    recsDe(nome).forEach(r=>{ mrrTotal+=Number(r.mensalidade)||0; valorContratos+=valorContrato(r); });
    return { projServ, mrrTotal, valorContratos };
  };
  const marcarPago = async(nome)=>{ const t=totalVend(nome).total; if(t<=0) return; try{ await api.post("/comissoes/pagar",{ vendedor:nome, mes, valor:t }); }catch(e){ return alert("Apenas o gestor pode registrar pagamento."); } carregarPagos(mes); };
  const desfazerPago = async(nome)=>{ try{ await api.post("/comissoes/despagar",{ vendedor:nome, mes }); }catch(e){ return alert("Apenas o gestor pode desfazer."); } carregarPagos(mes); };

  const [np,setNp] = useState({ cliente:"", valorServicos:"", origem:1, reter:true });
  const [nr,setNr] = useState({ cliente:"", mensalidade:"", dataInicio:"", dataFim:"" });
  const [editP,setEditP] = useState(null);
  const [editR,setEditR] = useState(null);

  const salvarProjeto = async()=>{
    if(!vend) return alert("Selecione um vendedor");
    if(!np.cliente.trim() && !np.valorServicos) return;
    const body={ vendedor:vend, tipo:"projeto", mes, cliente:np.cliente, valorServicos:Number(np.valorServicos)||0, origem:Number(np.origem), reter:np.reter };
    try{ if(editP) await api.put("/comissoes/"+editP, body); else await api.post("/comissoes", body); }
    catch(e){ return alert("Apenas o gestor pode lançar comissões."); }
    setNp({ cliente:"", valorServicos:"", origem:1, reter:true }); setEditP(null); carregar();
  };
  const salvarRec = async()=>{
    if(!vend) return alert("Selecione um vendedor");
    if(!nr.cliente.trim() && !nr.mensalidade) return;
    const body={ vendedor:vend, tipo:"recorrente", mes, cliente:nr.cliente, mensalidade:Number(nr.mensalidade)||0, dataInicio:nr.dataInicio, dataFim:nr.dataFim };
    try{ if(editR) await api.put("/comissoes/"+editR, body); else await api.post("/comissoes", body); }
    catch(e){ return alert("Apenas o gestor pode lançar comissões."); }
    setNr({ cliente:"", mensalidade:"", dataInicio:"", dataFim:"" }); setEditR(null); carregar();
  };
  const editarProjeto = (r)=>{ setEditP(r._id); setNp({ cliente:r.cliente||"", valorServicos:r.valorServicos||"", origem:r.origem, reter:r.reter }); };
  const editarRec = (r)=>{ setEditR(r._id); setNr({ cliente:r.cliente||"", mensalidade:r.mensalidade||"", dataInicio:(r.dataInicio||"").slice(0,10), dataFim:(r.dataFim||"").slice(0,10) }); };
  const excluir = async(id)=>{ if (!window.confirm("Excluir esta comissão?")) return; try{ await api.delete("/comissoes/"+id); }catch(e){ return alert("Apenas o gestor pode excluir."); } carregar(); };

  const projs = projsDe(vend);
  const recs  = recsDe(vend);
  const tv = totalVend(vend);

  return (
    <div style={{ fontFamily:"'Inter',sans-serif", padding:"20px 24px 60px", maxWidth:1180, margin:"0 auto" }}>

      {!isGestor && (
        <div style={{ ...card, marginBottom:16, borderLeft:"4px solid #0984e3", display:"flex", alignItems:"center", gap:10 }}>
          <span style={{ fontSize:18 }}>👁️</span>
          <span style={{ fontSize:13, color:"var(--text-secondary)" }}>Modo visualização — você acompanha suas comissões. O lançamento de contratos é feito pelo gestor.</span>
        </div>
      )}

      <div style={{ ...card, marginBottom:16 }}>
        <div style={{ display:"flex", alignItems:"flex-start", gap:20, flexWrap:"wrap" }}>
          <div>
            <label style={lbl}>Mês de referência</label>
            <div style={{ display:"flex", alignItems:"center", gap:6 }}>
              <button onClick={()=>setMes(shiftMes(mes,-1))} title="Mês anterior" style={{ ...inp, width:38, padding:0, cursor:"pointer", fontSize:18, fontWeight:700, color:"var(--text-secondary)", display:"flex", alignItems:"center", justifyContent:"center" }}>‹</button>
              <input type="month" value={mes} onChange={e=>setMes(e.target.value)} style={{ ...inp, width:160 }}/>
              <button onClick={()=>setMes(shiftMes(mes,1))} title="Próximo mês" style={{ ...inp, width:38, padding:0, cursor:"pointer", fontSize:18, fontWeight:700, color:"var(--text-secondary)", display:"flex", alignItems:"center", justifyContent:"center" }}>›</button>
            </div>
          </div>
          <div style={{ flex:1, minWidth:220 }}>
            <label style={lbl}>Vendedor</label>
            {isGestor ? (
              <div style={{ display:"flex", flexWrap:"wrap", gap:8 }}>
                {usuarios.map(u=>{
                  const t=totalVend(u.nome); const on=vend===u.nome;
                  return (
                    <button key={u._id||u.nome} onClick={()=>setVend(u.nome)}
                      style={{ display:"flex", flexDirection:"column", alignItems:"flex-start", gap:2, padding:"7px 14px", borderRadius:9, cursor:"pointer", border:"1.5px solid "+(on?ORANGE:"var(--border-color)"), background:on?ORANGE+"14":"var(--card-bg)" }}>
                      <span style={{ fontSize:12.5, fontWeight:700, color:on?ORANGE:"var(--text-primary)" }}>{(u.nome||"").split(" ")[0]}</span>
                      <span style={{ fontSize:11, fontWeight:600, color: t.total>0?"#10b981":"var(--text-muted)" }}>{BRL(t.total)}</span>
                    </button>
                  );
                })}
              </div>
            ) : (
              <div style={{ display:"inline-flex", alignItems:"center", gap:8, padding:"9px 14px", borderRadius:9, border:"1.5px solid "+ORANGE, background:ORANGE+"14" }}>
                <span style={{ fontSize:13, fontWeight:700, color:ORANGE }}>{vend||"—"}</span>
              </div>
            )}
          </div>
        </div>
      </div>

      <div style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:12, marginBottom:16 }}>
        {[["Projetos (a pagar)",tv.proj,ORANGE],["Fechamento recorrente",tv.fech,"#6c5ce7"],["Residual do mês",tv.resMes,"#0984e3"],["Total no mês",tv.total,"#10b981"]].map(([k,v,c],i)=>(
          <div key={i} style={{ ...card, padding:16 }}>
            <div style={{ fontSize:10.5, fontWeight:600, color:"var(--text-muted)", textTransform:"uppercase", letterSpacing:".04em" }}>{k}</div>
            <div style={{ fontSize:22, fontWeight:800, color:c, marginTop:6 }}>{BRL(v)}</div>
          </div>
        ))}
      </div>

      {(()=>{ const vf=totalFechado(vend); return (
      <div style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:12, marginBottom:16 }}>
        {[["Projetos fechados (serviços)",vf.projServ,"var(--text-primary)"],["Contratos ativos (MRR)",vf.mrrTotal,"#0984e3"],["Valor total dos contratos",vf.valorContratos,"#6c5ce7"]].map(([k,v,c],i)=>(
          <div key={i} style={{ ...card, padding:16 }}>
            <div style={{ fontSize:10.5, fontWeight:600, color:"var(--text-muted)", textTransform:"uppercase", letterSpacing:".04em" }}>{k}</div>
            <div style={{ fontSize:20, fontWeight:800, color:c, marginTop:6 }}>{BRL(v)}</div>
          </div>
        ))}
      </div>
      ); })()}

      {/* Projetos */}
      <div style={{ ...card, marginBottom:16 }}>
        <div style={secTit}>Projetos & Serviços</div>
        <table style={{ width:"100%", borderCollapse:"collapse" }}>
          <thead><tr>
            <th style={th}>Cliente</th><th style={{...th,textAlign:"right"}}>Valor serviços</th>
            <th style={{...th,textAlign:"center"}}>Origem</th><th style={{...th,textAlign:"center"}}>Ret.</th>
            <th style={{...th,textAlign:"right"}}>A pagar</th><th style={{...th,width:64,textAlign:"center"}}></th>
          </tr></thead>
          <tbody>
            {projs.map(r=>{ const c=comProjeto(par,r.valorServicos,r.origem,r.reter); return (
              <tr key={r._id} style={{ background: editP===r._id?ORANGE+"0d":"transparent" }}>
                <td style={{...td,color:"var(--text-primary)",fontWeight:600}}>{r.cliente||"—"}</td>
                <td style={{...td,textAlign:"right"}}>{BRL(r.valorServicos)}</td>
                <td style={{...td,textAlign:"center"}}>{PCT(r.origem)}</td>
                <td style={{...td,textAlign:"center"}}>{r.reter?"20%":"—"}</td>
                <td style={{...td,textAlign:"right",fontWeight:800,color:ORANGE}}>{BRL(c.aPagar)}</td>
                <td style={{...td,textAlign:"center",whiteSpace:"nowrap"}}>
                  {isGestor && <>
                  <span onClick={()=>editarProjeto(r)} style={{...iconBtn,color:"#579bfc"}}>✎</span>
                  <span onClick={()=>excluir(r._id)} style={{...iconBtn,color:"#e2445c"}}>×</span>
                  </>}
                </td>
              </tr>
            );})}
            {projs.length===0 && <tr><td style={{...td,color:"var(--text-muted)"}} colSpan={6}>Nenhum projeto lançado neste mês.</td></tr>}
          </tbody>
        </table>

        {isGestor && (
        <div style={{ display:"grid", gridTemplateColumns:"1fr 170px 250px 100px 130px", gap:12, alignItems:"end", marginTop:16, paddingTop:16, borderTop:"1px solid var(--border-light)" }}>
          <div><label style={lbl}>Cliente {editP&&<span style={{color:ORANGE}}>· editando</span>}</label><input value={np.cliente} onChange={e=>setNp({...np,cliente:e.target.value})} placeholder="Nome do cliente" style={inp}/></div>
          <div><label style={lbl}>Valor de serviços</label><Money value={np.valorServicos} onChange={v=>setNp({...np,valorServicos:v})}/></div>
          <div><label style={lbl}>Origem</label>
            <select value={np.origem} onChange={e=>setNp({...np,origem:Number(e.target.value)})} style={{...inp,appearance:"auto"}}>
              <option value={1}>Cliente novo / minha carteira — 100%</option>
              <option value={0.5}>Inbound / indicação / subcontratado — 50%</option>
              <option value={0}>Conta da casa (carteira da empresa) — 0%</option>
            </select>
          </div>
          <div><label style={lbl}>Retenção</label>
            <label style={{ display:"flex", alignItems:"center", gap:6, fontSize:13, color:"var(--text-secondary)", height:38 }}>
              <input type="checkbox" checked={np.reter} onChange={e=>setNp({...np,reter:e.target.checked})}/> 20%
            </label>
          </div>
          <div style={{ display:"flex", gap:6 }}>
            <button onClick={salvarProjeto} style={btnAdd}>{editP?"Salvar":"+ Adicionar"}</button>
            {editP&&<button onClick={()=>{ setEditP(null); setNp({cliente:"",valorServicos:"",origem:1,reter:true}); }} style={{...btnAdd, background:"var(--hover-bg)", color:"var(--text-secondary)", padding:"0 10px"}}>✕</button>}
          </div>
        </div>
        )}
      </div>

      {/* Recorrente */}
      <div style={{ ...card, marginBottom:16 }}>
        <div style={secTit}>Contratos recorrentes</div>
        <div style={{ fontSize:11.5, color:"var(--text-muted)", marginTop:-8, marginBottom:12 }}>Fechamento entra só no mês em que o contrato fecha; do 2º ao 12º mês entra o residual. Troque o mês no topo para ver o que cada contrato paga.</div>
        <table style={{ width:"100%", borderCollapse:"collapse" }}>
          <thead><tr>
            <th style={th}>Cliente</th><th style={{...th,textAlign:"right"}}>Mensalidade</th>
            <th style={{...th,textAlign:"center"}}>Início</th><th style={{...th,textAlign:"center"}}>Fim</th>
            <th style={{...th,textAlign:"right"}}>Valor contrato</th>
            <th style={{...th,textAlign:"center"}}>Situação no mês</th>
            <th style={{...th,textAlign:"right"}}>Comissão no mês</th><th style={{...th,width:64,textAlign:"center"}}></th>
          </tr></thead>
          <tbody>
            {recs.map(r=>{ const s=situacaoRec(par,mes,r); const al=alertaFim(r.dataFim); return (
              <tr key={r._id} style={{ background: editR===r._id?ORANGE+"0d":"transparent" }}>
                <td style={{...td,color:"var(--text-primary)",fontWeight:600}}>{r.cliente||"—"}</td>
                <td style={{...td,textAlign:"right"}}>{BRL(r.mensalidade)}</td>
                <td style={{...td,textAlign:"center"}}>{fmtData(r.dataInicio)}</td>
                <td style={{...td,textAlign:"center"}}>
                  <div>{fmtData(r.dataFim)}</div>
                  {al&&<span style={{ display:"inline-block", marginTop:3, fontSize:10.5, fontWeight:700, color:al.cor, background:al.cor+"1a", borderRadius:99, padding:"1px 8px" }}>{al.txt}</span>}
                </td>
                <td style={{...td,textAlign:"right"}}>{BRL(valorContrato(r))}</td>
                <td style={{...td,textAlign:"center",color:s.cor,fontWeight:600}}>{s.txt}</td>
                <td style={{...td,textAlign:"right",fontWeight:800,color:s.cor}}>{s.val>0?BRL(s.val):"—"}</td>
                <td style={{...td,textAlign:"center",whiteSpace:"nowrap"}}>
                  {isGestor && <>
                  <span onClick={()=>editarRec(r)} style={{...iconBtn,color:"#579bfc"}}>✎</span>
                  <span onClick={()=>excluir(r._id)} style={{...iconBtn,color:"#e2445c"}}>×</span>
                  </>}
                </td>
              </tr>
            );})}
            {recs.length===0 && <tr><td style={{...td,color:"var(--text-muted)"}} colSpan={8}>Nenhum contrato cadastrado.</td></tr>}
          </tbody>
        </table>

        {isGestor && (
        <div style={{ display:"grid", gridTemplateColumns:"1fr 160px 155px 155px 130px", gap:12, alignItems:"end", marginTop:16, paddingTop:16, borderTop:"1px solid var(--border-light)" }}>
          <div><label style={lbl}>Cliente {editR&&<span style={{color:ORANGE}}>· editando</span>}</label><input value={nr.cliente} onChange={e=>setNr({...nr,cliente:e.target.value})} placeholder="Nome do cliente" style={inp}/></div>
          <div><label style={lbl}>Mensalidade</label><Money value={nr.mensalidade} onChange={v=>setNr({...nr,mensalidade:v})}/></div>
          <div><label style={lbl}>Início</label><input type="date" value={nr.dataInicio} onChange={e=>setNr({...nr,dataInicio:e.target.value})} style={inp}/></div>
          <div><label style={lbl}>Fim do contrato</label><input type="date" value={nr.dataFim} onChange={e=>setNr({...nr,dataFim:e.target.value})} style={inp}/></div>
          <div style={{ display:"flex", gap:6 }}>
            <button onClick={salvarRec} style={btnAdd}>{editR?"Salvar":"+ Adicionar"}</button>
            {editR&&<button onClick={()=>{ setEditR(null); setNr({cliente:"",mensalidade:"",dataInicio:"",dataFim:""}); }} style={{...btnAdd, background:"var(--hover-bg)", color:"var(--text-secondary)", padding:"0 10px"}}>✕</button>}
          </div>
        </div>
        )}
      </div>

      {isGestor && (
      <div style={{ ...card, marginBottom:16 }}>
        <div style={secTit}>Resumo do time — {mes}</div>
        <table style={{ width:"100%", borderCollapse:"collapse" }}>
          <thead><tr>
            <th style={th}>Vendedor</th>
            <th style={{...th,textAlign:"right"}}>Projetos fechados</th>
            <th style={{...th,textAlign:"right"}}>Contratos (MRR)</th>
            <th style={{...th,textAlign:"right"}}>Valor total contratos</th>
            <th style={{...th,textAlign:"right"}}>Comissão no mês</th>
            <th style={{...th,textAlign:"center"}}>Pagamento</th>
          </tr></thead>
          <tbody>
            {usuarios.map(u=>{ const vf=totalFechado(u.nome); const t=totalVend(u.nome); if(vf.projServ===0 && vf.mrrTotal===0 && t.total===0) return null; const pago=pagos.includes(u.nome); return (
              <tr key={u._id||u.nome}>
                <td style={{...td,color:"var(--text-primary)",fontWeight:600}}>{u.nome}</td>
                <td style={{...td,textAlign:"right"}}>{BRL(vf.projServ)}</td>
                <td style={{...td,textAlign:"right"}}>{BRL(vf.mrrTotal)}</td>
                <td style={{...td,textAlign:"right"}}>{BRL(vf.valorContratos)}</td>
                <td style={{...td,textAlign:"right",fontWeight:800,color:"#10b981"}}>{BRL(t.total)}</td>
                <td style={{...td,textAlign:"center"}}>
                  {pago ? (
                    <span style={{ display:"inline-flex", alignItems:"center", gap:8 }}>
                      <span style={{ fontSize:11.5, fontWeight:700, color:"#0f6e56", background:"#0f6e5618", borderRadius:999, padding:"3px 10px" }}>Paga</span>
                      <span onClick={()=>desfazerPago(u.nome)} style={{ cursor:"pointer", fontSize:11, color:"var(--text-muted)", textDecoration:"underline" }}>desfazer</span>
                    </span>
                  ) : (
                    <button onClick={()=>marcarPago(u.nome)} style={{ background:ORANGE, color:"#fff", border:"none", borderRadius:7, padding:"5px 12px", fontSize:12, fontWeight:700, cursor:"pointer" }}>Marcar paga</button>
                  )}
                </td>
              </tr>
            );})}
            {(()=>{ const tp=usuarios.reduce((a,u)=>a+totalFechado(u.nome).projServ,0); const tm=usuarios.reduce((a,u)=>a+totalFechado(u.nome).mrrTotal,0); const tvc=usuarios.reduce((a,u)=>a+totalFechado(u.nome).valorContratos,0); const tc=usuarios.reduce((a,u)=>a+totalVend(u.nome).total,0); return (
              <tr style={{ background:"var(--hover-bg)" }}>
                <td style={{...td,fontWeight:800,color:"var(--text-primary)"}}>Total do time</td>
                <td style={{...td,textAlign:"right",fontWeight:800}}>{BRL(tp)}</td>
                <td style={{...td,textAlign:"right",fontWeight:800}}>{BRL(tm)}</td>
                <td style={{...td,textAlign:"right",fontWeight:800}}>{BRL(tvc)}</td>
                <td style={{...td,textAlign:"right",fontWeight:800,color:"#10b981"}}>{BRL(tc)}</td>
                <td style={td}></td>
              </tr>
            ); })()}
          </tbody>
        </table>
        <div style={{ fontSize:11.5, color:"var(--text-muted)", marginTop:10 }}>Ao marcar como paga, uma despesa é lançada no Financeiro (categoria Comissões). Desfazer remove o lançamento.</div>
      </div>
      )}

      {/* Parâmetros */}
      {isGestor && (
      <div style={card}>
        <div onClick={()=>setOpenPar(o=>!o)} style={{ display:"flex", alignItems:"center", justifyContent:"space-between", cursor:"pointer" }}>
          <div style={{ ...secTit, marginBottom:0 }}>Parâmetros das regras</div>
          <span style={{ color:"var(--text-muted)", fontSize:13 }}>{openPar?"▾ ocultar":"▸ editar"}</span>
        </div>
        {openPar && (
          <div style={{ marginTop:16 }}>
            <div style={{ fontSize:12, fontWeight:700, color:"var(--text-secondary)", marginBottom:10 }}>Faixas do projeto (% sobre serviços)</div>
            <div style={{ display:"grid", gridTemplateColumns:"1fr 160px 120px", gap:10, marginBottom:6 }}>
              <span style={{...lbl, marginBottom:0}}>Faixa</span><span style={{...lbl, marginBottom:0}}>Até (R$)</span><span style={{...lbl, marginBottom:0}}>%</span>
            </div>
            {par.faixas.map((f,i)=>(
              <div key={i} style={{ display:"grid", gridTemplateColumns:"1fr 160px 120px", gap:10, marginBottom:8, alignItems:"center" }}>
                <span style={{ fontSize:13, color:"var(--text-secondary)" }}>Faixa {i+1}{f.ate==null?" (acima)":""}</span>
                <input type="number" value={f.ate==null?"":f.ate} placeholder="∞" onChange={e=>setPar(p=>{const fx=p.faixas.map((x,j)=>j===i?{...x,ate:e.target.value===""?null:Number(e.target.value)}:x);return{...p,faixas:fx};})} style={inp}/>
                <input type="number" value={f.pct*100} onChange={e=>setPar(p=>{const fx=p.faixas.map((x,j)=>j===i?{...x,pct:Number(e.target.value)/100}:x);return{...p,faixas:fx};})} style={inp}/>
              </div>
            ))}
            <div style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:12, marginTop:16 }}>
              <div><label style={lbl}>Retenção projeto (%)</label><input type="number" value={par.retencao*100} onChange={e=>setPar(p=>({...p,retencao:Number(e.target.value)/100}))} style={inp}/></div>
              <div><label style={lbl}>Fechamento recorrente (%)</label><input type="number" value={par.recFech*100} onChange={e=>setPar(p=>({...p,recFech:Number(e.target.value)/100}))} style={inp}/></div>
              <div><label style={lbl}>Residual /mês (%)</label><input type="number" value={par.recResid*100} onChange={e=>setPar(p=>({...p,recResid:Number(e.target.value)/100}))} style={inp}/></div>
              <div><label style={lbl}>Parcelas residual</label><input type="number" value={par.recParcelas} onChange={e=>setPar(p=>({...p,recParcelas:Number(e.target.value)}))} style={inp}/></div>
            </div>
            <button onClick={()=>setPar(PADRAO)} style={{ marginTop:16, background:"var(--hover-bg)", border:"1px solid var(--border-color)", borderRadius:8, padding:"9px 18px", color:"var(--text-secondary)", fontWeight:600, fontSize:12.5, cursor:"pointer" }}>Restaurar padrão</button>
          </div>
        )}
      </div>
      )}
    </div>
  );
}
